import preloadRegistry from './preload-registry.directive'
import preloadRegistryService from './preload-registry.service'

const module = angular.module('ac.components.preloadregistry', [])

module.directive('preloadRegistry', preloadRegistry).service('preloadRegistryService', preloadRegistryService)

export default module.name
